module.exports = __webpack_public_path__ + "static/media/add.0c59620c.png";